import messageChannelService from '../message-channel.service'
import { withRetry } from '../../../utilities/pinpad-v2/retry'
import { logInfo, logError } from '../../../utilities/pinpad-v2/logger'

class MerchantService {
  normalizeAffiliations(node) {
    if (!node) return []
    if (Array.isArray(node)) return node
    if (typeof node === 'object') return [node]
    return []
  }

  getContadoAffiliations(response) {
    return this.normalizeAffiliations(response?.contado?.af)
  }

  getMSIAffiliations(response) {
    return this.normalizeAffiliations(response?.msi?.af)
  }

  getMCIAffiliations(response) {
    if (!response?.plazosmci || typeof response.plazosmci !== 'string') return []
    return response.plazosmci.split(',').map((value) => value.trim()).filter(Boolean)
  }

  async getMerchant(params) {
    const payload = {
      Ambiente: params?.Ambiente,
      BIN: params?.BIN,
      User: params?.User,
      Currency: params?.Currency,
      Tx_OperationType: params?.Tx_OperationType
    }

    const required = ['Ambiente', 'BIN', 'User', 'Currency', 'Tx_OperationType']
    const missing = required.filter((field) => !payload[field])
    if (missing.length) {
      const error = new Error(`Missing required parameters: ${missing.join(', ')}`)
      error.code = 'INVALID_PARAMETERS'
      throw error
    }

    const getMerchantFn = async () => {
      logInfo('getMerchant payload prepared', {
        payload,
      })

      const response = await messageChannelService.sendMessage('getMerchant', payload, 30000)

      logInfo('getMerchant response received', {
        bin: payload.BIN,
        response,
      })

      if (!response || response.RESPUESTA === 'error') {
        const error = new Error(response?.ERROR || 'getMerchant failed')
        error.code = response?.codError || 'GET_MERCHANT_ERROR'
        throw error
      }
      if (!response.respuesta || response.respuesta === '0') {
        const error = new Error(response?.nb_respuesta || 'No affiliations available')
        error.code = response?.codError || 'NO_AFFILIATIONS'
        throw error
      }
      return response
    }

    try {
      logInfo('Starting getMerchant operation', { bin: payload.BIN, currency: payload.Currency })
      return await withRetry(getMerchantFn, { operation: 'GET_MERCHANT' })
    } catch (error) {
      logError('getMerchant failed', error, { bin: payload.BIN, currency: payload.Currency })
      throw error
    }
  }
}

const merchantService = new MerchantService()

export default merchantService
